import { Component, OnInit } from '@angular/core'
import { UserListService } from '../pages/users/user-list/user-list.service';
import { MasterService } from '../master/master.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  totalUsers: number = 0;
  totalRoles: number = 0;
  currentUser: any = JSON.parse(localStorage.getItem('currentUser') || '{}');

  // Dashboard analytics properties
  dashboardData: any = null;
  overview: any = null;
  overall: any = null;
  departmentStats: any[] = [];
  dailyCallStats: any[] = [];
  dailyStats: any[] = [];
  lastUpdated: string = '';
  isAdmin: boolean = false;

  constructor(private userListService: UserListService, private masterService: MasterService) { }

  public contentHeader: object

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit() {
    // console.log("currentUser >>>", this.currentUser);
    if (this.currentUser == null || this.currentUser == '' || this.currentUser == undefined || Object.keys(this.currentUser).length === 0) {
      localStorage.clear();
      window.location.href = '/pages/login';
    }

    this.isAdmin = this.currentUser.role === 'admin';
    
    if (this.isAdmin) {
      this.masterService.dashboardStats().subscribe(res => {
        this.setDashboardData(res);
      });
    } else {
      this.masterService.agentCallStats().subscribe(res => {
        this.setAgentDashboardData(res);
      });
    }
  }

  setDashboardData(data: any) {
    this.dashboardData = data;
    this.overview = data.overview || {};
    this.departmentStats = data.departmentStats || [];
    this.dailyCallStats = data.dailyCallStats || [];
    this.lastUpdated = data.lastUpdated || '';
  }

  setAgentDashboardData(data: any) {
    this.dashboardData = data;
    this.overall = data.overall || {};
    this.departmentStats = data.departmentStats || [];
    this.dailyStats = data.dailyStats || [];
    this.lastUpdated = data.lastUpdated || '';
  }

    // this.contentHeader = {
    //   headerTitle: 'Home',
    //   actionButton: true,
    //   breadcrumb: {
    //     type: '',
    //     links: [
    //       {
    //         name: 'Home',
    //         isLink: true,
    //         link: '/'
    //       },
    //       {
    //         name: 'Dashboard',
    //         isLink: false
    //       }
    //     ]
    //   }
    // } 

}
